import createCachedSelector from 're-reselect'

import type { State as StateType } from '../../reducers'
import type { DraftStoreType } from '../../reducers/draft/draft'
import type { JobPostingProduct } from '../../reducers/entitlement/entitlement'

export const selectDraft = (state: StateType): DraftStoreType => state.draft
export const selectDraftProduct = (state: StateType): JobPostingProduct => state.draft.product

export const doesProductHavePredefinedField = createCachedSelector(
  [(state: StateType, fieldName: string): boolean => {
    if (fieldName === 'contract.contractTypes') {
      return state.draft.product.predefined && state.draft.product.predefined.employmenttype != null
    }
    return false
  }],
  value => value
)(() => 'nocache')

export const getPredefinedFieldValue = createCachedSelector(
  [(state: StateType, fieldName: string): string[] | undefined => {
    if (fieldName === 'contract.contractTypes') {
      if (state.draft.product.predefined && state.draft.product.predefined.employmenttype) {
        return [state.draft.product.predefined.employmenttype]
      }
    }
    return null
  }],
  value => value
)(() => 'nocache')
